import { render } from "./NavbarFour.vue?vue&type=template&id=4350b8fd&ts=true"
import script from "./NavbarFour.vue?vue&type=script&lang=ts"
export * from "./NavbarFour.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__